//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import map from '../../assets/images/map.svg';
import avatar1 from '../../assets/images/avatar1.webp';
import avatar2 from '../../assets/images/avatar2.webp';
import avatar3 from '../../assets/images/avatar3.webp';
import avatar4 from '../../assets/images/avatar4.webp';
import avatar5 from '../../assets/images/avatar5.webp';
import avatar6 from '../../assets/images/avatar6.webp';
import avatar7 from '../../assets/images/avatar7.webp';
import avatar8 from '../../assets/images/avatar8.webp';
import avatar9 from '../../assets/images/avatar9.webp';
import avatar10 from '../../assets/images/avatar10.webp';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const [isImagesLoaded, setIsImagesLoaded] = useState(false);

  const avatars = [
    { src: avatar1, alt: 'user1' },
    { src: avatar2, alt: 'user2' },
    { src: avatar3, alt: 'user3' },
    { src: avatar4, alt: 'user4' },
    { src: avatar5, alt: 'user5' },
    { src: avatar6, alt: 'user6' },
    { src: avatar7, alt: 'user7' },
    { src: avatar8, alt: 'user8' },
    { src: avatar9, alt: 'user9' },
    { src: avatar10, alt: 'user10' },
  ];

  useEffect(() => {
    const allImages = [map, ...avatars.map((a) => a.src)];
    const preload = allImages.map((src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = resolve;
      });
    });

    Promise.all(preload).then(() => {
      setIsImagesLoaded(true);
    });
  }, []);

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.container}>
        <div className={styles.wrapperInfo}>
          <Title className={styles.title}>{t('onboarding.trusted.title')}</Title>
          <Text semibold className={styles.description}>
            {t('onboarding.trusted.description')}
          </Text>
        </div>

        <div className={styles.imageContainer}>
          <img src={map} className={styles.map} alt='map' />
          {avatars.map((avatar, index) => (
            <div
              key={index}
              className={`${styles.avatarContainer} ${styles[`avatarContainer${index + 1}`]}`}
            >
              <img src={avatar.src} className={styles[`avatar${index + 1}`]} alt={avatar.alt} />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.continue}>
        <div className={styles.blur}></div>
        <Button onClick={onNext} title={t('onboarding.trusted.continue')} />
      </div>
    </div>
  );
}

export default Page;
